// Question simple type QCM : une question et plusieurs réponses possibles. Il faut en choisir une et ça passe à la correction.

import React from 'react';

const SlideClassicQuestion = ({ slide, setPoints, points, changeState, setRight }) => {

  const rightAnswer = () => {
    setPoints(points + 10);
    changeState();
  }

  const wrongAnswer = () => {
    setRight(false);
    changeState();
  }

  const addLazyLoadingToImages = (htmlString) => {
    // Crée un élément DOM temporaire pour manipuler la chaîne HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // Sélectionne toutes les balises <img> dans le contenu
    const images = tempDiv.querySelectorAll('img');

    // Ajoute l'attribut loading="lazy" à chaque image
    images.forEach((img) => {
      img.setAttribute('loading', 'lazy');
    });

    // Retourne le HTML modifié sous forme de chaîne
    return tempDiv.innerHTML;
  };

  return (
    <article className={"tplt-" + slide.template}>
      <div class="question" dangerouslySetInnerHTML={{ __html: slide.question }}>

      </div>
      <ul className={"answers " + slide.answers_display}>
        {
          JSON.parse(slide.answers)?.map((answer, index) => (
            <li className={answer.includes("<img") ? "" : ""} key={index}>
              <button className='classic-question-button' onClick={() => parseInt(slide.good_answer) === index ? rightAnswer() : wrongAnswer()} dangerouslySetInnerHTML={{ __html: addLazyLoadingToImages(answer) }}></button>
            </li>
          ))
        }
      </ul>
    </article>
  );
};

export default SlideClassicQuestion;